export default __webpack_public_path__ + "0cf2decf731c2e743792ba53a284055c.webp";